import { createReducer, on } from '@ngrx/store';
import {
  readAssignments,
  readAssignmentsFailure,
  readAssignmentsSuccess,
} from './assignment.actions';
import { AssignmentDto } from '@shared/dto';
import { logout } from '@auth/store/auth.actions';
import { State } from '@store/state.interface';

export const ASSIGNMENT_FEATURE_KEY = 'assignments';

export interface AssignmentState extends State<AssignmentDto> {}

export const initialState: AssignmentState = {
  data: null,
  detail: null,
  loading: false,
  query: null,
  error: null,
};

export const assignmentReducer = createReducer(
  initialState,
  on(readAssignments, (state, { memberId, deleted }) => ({
    ...state,
    loading: true,
    error: null,
    query: {
      ...(deleted ? { deleted: true } : {}),
      ...(memberId != null ? { filters: { memberId } } : {}),
    },
  })),
  on(readAssignmentsSuccess, (state, { data }) => ({ ...state, data, loading: false })),
  on(readAssignmentsFailure, (state, { error }) => ({ ...state, loading: false, error })),
  on(logout, () => initialState),
);
